import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInputComponent from '../../Common/PlainInputComponent';
const FullNameAndKanaFieldsAndLabel = (props) => {
    const { firstName, firstNameKana, lastName, lastNameKana } = props;
    const getError = (data) => {
        if (data.meta.touched && data.meta.error) {
            return data.meta.error;
        }
        return '';
    };
    const lastNameError = getError(lastName);
    const firstNameError = getError(firstName);
    const lastNameKanaError = getError(lastNameKana);
    const firstNameKanaError = getError(firstNameKana);
    return (_jsxs("div", Object.assign({ className: 'form form-solution cf req' }, { children: [_jsx("h3", { children: "\u6C0F\u540D" }), _jsxs("div", Object.assign({ className: 'mb8 is-ohidden' }, { children: [_jsx(PlainInputComponent, { className: `input-form-text is-half ${lastNameError ? 'is-warning' : ''}`, input: lastName.input, meta: lastName.meta, placeholder: '姓', showError: false }), _jsx(PlainInputComponent, { className: `input-form-text is-half ${firstNameError ? 'is-warning' : ''}`, input: firstName.input, meta: firstName.meta, placeholder: '名', showError: false })] })), _jsxs("div", Object.assign({ className: 'mb8 is-ohidden' }, { children: [_jsx(PlainInputComponent, { className: `input-form-text is-half ${lastNameKanaError ? 'is-warning' : ''}`, input: lastNameKana.input, meta: lastNameKana.meta, placeholder: 'セイ', showError: false }), _jsx(PlainInputComponent, { className: `input-form-text is-half ${firstNameKanaError ? 'is-warning' : ''}`, input: firstNameKana.input, meta: firstNameKana.meta, placeholder: 'メイ', showError: false })] })), _jsx(InputError, { error: lastNameError ||
                    firstNameError ||
                    lastNameKanaError ||
                    firstNameKanaError })] })));
};
FullNameAndKanaFieldsAndLabel.propTypes = {
    firstName: propShape().isRequired,
    firstNameKana: propShape().isRequired,
    lastName: propShape().isRequired,
    lastNameKana: propShape().isRequired,
};
export default FullNameAndKanaFieldsAndLabel;
